import { Component, OnInit, Input, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { IRoute } from 'src/app/interfaces/route';
import { IMap } from 'src/app/interfaces/map';
import { UtilsService } from 'src/app/services/utils.service';
import { ITravelMode } from 'src/app/interfaces/travel-mode';

declare var jQuery: any;

@Component({
  selector: 'app-journey-options',
  templateUrl: './journey-options.component.html',
  styleUrls: ['./journey-options.component.scss']
})
export class JourneyOptionsComponent implements OnInit, AfterViewChecked {
  @Input() routes: IRoute[];
  @Input() setMap: Function;
  @Input() map: {
    sameLocation: boolean,
    data: { [mode: string]: IMap },
    origins: { [mode: string]: Location },
    hasMap: { [mode: string]: boolean }
    selectedMap: ITravelMode,
  };
  public Object = Object;
  public sortBy: 'durationSecs' | 'co2Kg' | 'noxG' | 'cals' | 'distance' = 'co2Kg';
  public descriptions = {
    nox: `Nitrogen oxide (NO<sub>x</sub>) is a chemical compound of oxygen and nitrogen that is
          formed by reacting with each other during combustion at high temperatures,
          mainly combustion of fuel such as oil, diesel, gas and organic matter. NO<sub>x</sub>
          is a common designation of nitrogen oxides NO and NO<sub>2</sub>. NO<sub>x</sub> can cause serious
          health damage to humans, including respiratory diseases. NO<sub>x</sub> is also responsible
          for smog and the typical brown cloud that covers larger cities and produces
          poor air quality. NO<sub>x</sub> emissions contribute to acid rain and formation of ground-level
          ozone that can damage ecosystems, animal and plant life.<br/>
          Source: <a href="https://www.nho.no/samarbeid/nox-fondet/the-nox-fund/articles/what-is-nox/">NHO</a>`,
    co2: `Carbon dioxide (CO2) is an important heat-trapping (greenhouse) gas, which is released through human
          activities such as deforestation and burning fossil fuels. For further info see:
          <a href="https://climate.nasa.gov/vital-signs/carbon-dioxide/">NASA - Carbon Dioxide</a>
          and <a href="https://wwf.panda.org/our_work/climate_and_energy/">WWF - Climate and Energy</a>`,
    cals: `A calorie is a measure of energy expenditure and stored energy. When used for exercise  kilocalories
          (kcal) are used to indicate calories burned. The amount displayed here is an average and the actual
          amount of Kcal burned is individual and depends among other things on how you exercise. See for example:
          <a href="https://www.nhs.uk/live-well/healthy-weight/understanding-calories/">NHS - Understanding calories</a>`
  };

  constructor(
    private utils: UtilsService,
    private changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {}

  ngAfterViewChecked(): void {
    this.utils.setPopovers();
  }

  closePopover() {
    this.utils.closePopover();
  }

  detectChanges() {
    this.changeDetector.detach();
    this.changeDetector.detectChanges();
    this.changeDetector.reattach();
  }

  setSort(sort) {
    this.sortBy = sort;
    this.detectChanges();
  }

}
